import styled from "styled-components";

export const NotesPanelContainer = styled.div`
  display: block;
  position: fixed;
  top: ${(props) => props.type === 'client-form' ? '60px' : '0'};
  right: 0;
  background: #fff;
  z-index: 1000;
  height: ${(props) => props.type === 'client-form' ? 'calc(100vh - 60px)' : '100vh'};
  width: ${(props) => props.toggleOption !== 'show-all' ? '320px' : '66%'};
  padding-top: 28px;
  box-shadow: -4px 0px 24px rgba(0, 0, 0, 0.10);
  overflow-y: auto;
  border-left: 1px solid #E5EAF2;
  transition: width 0.2s ease;
`;

export const NotesHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 12px 16px 12px;
  gap: 8px;
`;

export const NotesToggle = styled.div`
  background: #E5EAF2;
  border-radius: 6px;
  width: 260px;
  display: flex;
  flex-shrink: 0;
  padding: 3px;
`;

export const ToggleOption = styled.div`
  background: ${(props) => props.active ? '#fff' : 'transparent'};
  box-shadow: ${(props) => props.active ? '0px 1px 4px rgba(0,0,0,0.10)' : 'none'};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  flex: 1;
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: ${(props) => props.active ? '#0072E5' : '#6B7A90'};
  text-align: center;
  padding: 5px 4px;
  cursor: pointer;
  transition: all 0.15s ease;
`;

export const AddNoteButton = styled.div`
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #0072E5;
  cursor: pointer;
  &:hover { color: #0059B2; }
`;

export const AddNoteIcon = styled.img`
  margin-right: 6px;
  width: 16px;
  height: 16px;
`;

export const CardContainer = styled.div`
  background: ${(props) => props.editNoteInfo ? '#F3F6F9' : props.isAlert ? '#FFFBF0' : '#fff'};
  border: 1px solid ${(props) => props.isAlert ? '#FFD166' : '#E5EAF2'};
  border-left: ${(props) => props.isAlert ? '4px solid #FF9800' : '1px solid #E5EAF2'};
  border-radius: 8px;
  width: 282px;
  padding: 14px 16px;
  color: #1C2025;
  font-size: 12px;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  margin: 6px;
  transition: box-shadow 0.15s ease;
  &:hover { box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08); }
`;

export const AlertTag = styled.div`
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  background: #FFF3E0;
  color: #E65100;
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid #FFB74D;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const AlertField = styled.div`
  font-size: 11px;
  color: #6B7A90;
  margin-top: 4px;
  display: flex;
  gap: 4px;
  line-height: 1.5;
`;

export const AlertFieldLabel = styled.span`
  font-weight: 600;
  color: #B45309;
  min-width: 82px;
  flex-shrink: 0;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 6px;
  gap: 8px;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const CardName = styled.div`
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #1C2025;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CardDate = styled.div`
  font-size: 11px;
  color: #6B7A90;
  margin-top: 2px;
`;

export const CardStatus = styled.div`
  font-family: Inter, sans-serif;
  font-size: 11px;
  font-weight: 600;
  background: #EFF6FF;
  color: #0072E5;
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid #C2E0FF;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const CardText = styled.div`
  font-size: 12px;
  line-height: 1.6;
  color: #303740;
  width: 100%;
  white-space: pre-wrap;
  margin-top: 4px;
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 10px;
`;

export const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 0 6px 16px 6px;
`;

export const PanelCardsSearchInputContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  border-radius: 6px;
  padding: 5px 12px;
  background: #F3F6F9;
  border: 1px solid #E5EAF2;
  gap: 6px;
  min-width: 0;
`;

export const PanelCardsSearchInput = styled.input`
  outline: none;
  border: none;
  width: 100%;
  background: transparent;
  font-family: Inter, sans-serif;
  font-size: 13px;
  color: #1C2025;
  &::placeholder { color: #9DA8B7; }
`;

export const AddNoteFormContainer = styled.div`
  width: 100%;
  min-height: 200px;
  background: ${(props) => !props.editNoteInfo ? '#F3F6F9' : 'none'};
  padding: ${(props) => !props.editNoteInfo ? '16px' : '0px'};
  border-radius: ${(props) => !props.editNoteInfo ? '8px' : '0'};
  max-width: 282px;
  margin-left: 10px;
`;

export const FormTitle = styled.div`
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #1C2025;
  margin-bottom: 12px;
`;
